import {
  buildDashboardShow,
  buildReportShow,
  buildShowBoard,
  buildShowGlobalKpiList,
} from 'navigation/appRoutes';

import entityDetailsClientTabTypeCheckers from './entityDetailsClientTabTypeChckers';

const TAB_TYPE_LABELS: { [type in EntityDetails.TabType]: string } = {
  dashboard: 'Dashboard',
  board: 'Board',
  report: 'Report',
  scorecard: 'Scorecard',
  'driver-bonus-program-report': 'Driver Bonus Program',
  'driver-bonus-combined': 'Combined Bonus',
  'driver-details-tab': 'Driver Details',
  'bonus-app-embed': 'Bonus App',
};

/**
 * Derives display info for a tab's underlying artifact: a human-readable type
 * label and a link to the standalone artifact (dashboard/report/board/
 * scorecard).
 *
 * The link is version-aware: V3 serves every content type from the unified
 * `/content/:id` route, whereas V1/V2 use the per-type legacy routes. Bonus
 * program and driver-details tabs have no standalone route, so no link is
 * returned for them.
 */
const getTabArtifactInfo = ({
  tab,
  portal,
  isV3,
}: {
  tab: EntityDetails.ClientTab;
  portal: Portal | undefined;
  isV3: boolean;
}): { typeLabel: string; link?: string } => {
  const typeLabel = TAB_TYPE_LABELS[tab.type];

  if (entityDetailsClientTabTypeCheckers.isDashboardTab(tab)) {
    const link = isV3
      ? `/content/${tab.dashboard.id}`
      : buildDashboardShow({ id: tab.dashboard.id, portal });
    return { typeLabel, link };
  }
  if (entityDetailsClientTabTypeCheckers.isReportTab(tab)) {
    const link = isV3
      ? `/content/${tab.report.id}`
      : buildReportShow({ id: tab.report.id, portal });
    return { typeLabel, link };
  }
  if (entityDetailsClientTabTypeCheckers.isBoardTab(tab)) {
    const link = isV3
      ? `/content/${tab.board.id}`
      : buildShowBoard(tab.board.id);
    return { typeLabel, link };
  }
  if (entityDetailsClientTabTypeCheckers.isScorecardTab(tab)) {
    const link = isV3
      ? `/content/${tab.scorecard.id}`
      : buildShowGlobalKpiList({ scorecardId: tab.scorecard.id, portal });
    return { typeLabel, link };
  }

  return { typeLabel };
};

export default getTabArtifactInfo;
